<section class="field-history">
  @if (activities$ | async; as activities) {
    @if (activities.length) {
      <table>
        <thead>
          <tr class="mat-header-row">
            @if (multiFields) {
              <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">Field</th>
            }
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">New</th>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">Old</th>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">Date</th>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">User</th>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">Source</th>
          </tr>
        </thead>
        <tbody>
          @for (history of activities; track history) {
            <tr class="mat-row cdk-row order-row h-10">
              @if (multiFields) {
                <td class="mat-cell cdk-cell cdk-column-title mat-column-title val">
                  {{ getFieldDef(history.field).label }}
                </td>
              }
              <td class="mat-cell cdk-cell cdk-column-title mat-column-title val">
                {{ history.new_val | readableField: model : getFieldDef(history.field) : options }}
              </td>
              <td class="mat-cell cdk-cell cdk-column-title mat-column-title val">
                {{ history.old_val | readableField: model : getFieldDef(history.field) : options }}
              </td>
              <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                {{ history.created_at | date: 'LLL dd, y h:mm a' }}
              </td>
              <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                {{ history?.user_name }}
              </td>
              <td class="mat-cell cdk-cell cdk-column-title mat-column-title">
                {{ history?.source ?? '-' | titlecase }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <section class="flex flex-col items-center justify-center h-full pt-6">
        <mat-icon class="icon-size-32" [svgIcon]="'table_chart'"></mat-icon>
        <p class="text-xl text-secondary font-medium mt-4">No history to show</p>
      </section>
    }
  } @else {
    <section class="flex flex-col items-center justify-center h-full pt-6">
      <mat-spinner diameter="50"></mat-spinner>
    </section>
  }
</section>
